import React from 'react'

const MapaOrganizacion = () => {
    return (
        <div>
              <section className="page-section bg-light" id="team">
        <div className="container">
            <div className="text-center">
                <h2 className="section-heading text-uppercase">Mapa Organizacional</h2>
                <h3 className="section-subheading text-muted">Transparencia como pilar de nuestra empresa.</h3>
            </div>
            <div className="row">
                <div className="col-lg-3">
                    <div className="team-member">
                        <img className="mx-auto rounded-circle" src="assets/img/juandaiel.png" alt="..." />
                        <h4>Juan Daniel Suarez Amado</h4>
                        <p className="text-muted">Representante Legal</p>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-twitter"></i></a>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-facebook-f"></i></a>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="team-member">
                        <img className="mx-auto rounded-circle" src="assets/img/martinez.jpeg" alt="..." />
                        <h4>Michael Martinez Aldana</h4>
                        <p className="text-muted">Asesor Legal</p>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-twitter"></i></a>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-facebook-f"></i></a>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="team-member">
                        <img className="mx-auto rounded-circle" src="assets/img/juandiego.jpeg" alt="..." />
                        <h4>Juan Diego Parra</h4>
                        <p className="text-muted">Director Contable</p>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-twitter"></i></a>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-facebook-f"></i></a>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="team-member">
                        <img className="mx-auto rounded-circle" src="assets/img/Michael.jpeg" alt="..." />
                        <h4>Michael Rojas Vargas</h4>
                        <p className="text-muted">Director de Marketing</p>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-twitter"></i></a>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-facebook-f"></i></a>
                        <a className="btn btn-dark btn-social mx-2" href="#!"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
        </div>
    )
}

export default MapaOrganizacion
